export default {"src":"/_next/static/media/clock.a9f48c46.svg","height":23,"width":20,"blurWidth":0,"blurHeight":0};